export default function noop(): void {
  /* Do nothing */
}
